var map = {
	"./cn.json": 3189,
	"./en.json": 3268,
	"./fa.json": 6877,
	"./fr.json": 3594,
	"./ge.json": 9725,
	"./it.json": 5225,
	"./jp.json": 804,
	"./kor.json": 4430,
	"./pu.json": 8969,
	"./ru.json": 9846,
	"./sp.json": 1409,
	"./ta.json": 6665,
	"./tu.json": 2949,
	"./zh.json": 9035
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6617;